import PropTypes from 'prop-types'
import _ from 'lodash'
import yup from 'yup-legacy'
import createReactClass from 'create-react-class'

import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { Form, Submit } from 'legacy/libs/react-form-tools'
import { ProcessErrorsMixin } from 'legacy/libs/mixins'
import messages from 'legacy/common/messages'
import { twoTopLevelsTagRequired } from 'legacy/common/yupvalidators'
import { withGettext } from 'lib/gettext'
import CollapsibleStepContainer from '../collapsible-step-container'
import EntryTags from './entry-tags'

const SecondStep = createReactClass({
  mixins: [SchemaBranchMixin, ProcessErrorsMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    formCursor: BaobabPropTypes.cursor.isRequired,
    stepStateCursor: BaobabPropTypes.cursor.isRequired,
    rootEntryTagsCursor: BaobabPropTypes.cursor.isRequired,
    entryTagGroupsCursor: BaobabPropTypes.cursor,
    disableCollapsible: PropTypes.bool,
    onValidSubmit: PropTypes.func,
    submitText: PropTypes.string,
    onCollapsedChange: PropTypes.func,
    poll: PropTypes.any,
  },

  createValidationSchema(gettext) {
    return function (data) {
      return yup.object().shape({
        entryTags: yup
          .array()
          .required(gettext(messages.twoTopLevelsTagRequired))
          .required(gettext(messages.twoTagsFromEachRequiredGroupRequired))
          .of(yup.object())
          .test(
            'twoTopLevelsTagRequired',
            gettext(messages.twoTopLevelsTagRequired),
            twoTopLevelsTagRequired
          )
          .test(
            'twoTagsFromEachRequiredGroupRequired',
            gettext(messages.twoTagsFromEachRequiredGroupRequired),
            function () {
              const requiredGroups = _.filter(data.pollEntryTagGroups, {
                required: true,
              })

              return _.every(
                _.map(requiredGroups, (requiredGroup) => {
                  return !!(
                    _.find(data.entryTags, {
                      level: 1,
                      entryTagGroup: requiredGroup.pk,
                    }) &&
                    _.find(data.entryTags, {
                      level: 2,
                      entryTagGroup: requiredGroup.pk,
                    })
                  )
                })
              )
            }
          ),
      })
    }
  },

  cursors() {
    return {
      form: this.props.formCursor,
      stepState: this.props.stepStateCursor,
      rootEntryTags: this.props.rootEntryTagsCursor,
      entryTagGroups: this.props.entryTagGroupsCursor,
    }
  },

  onInvalidSubmit(errors) {
    this.cursors.stepState.set('collapsed', false)
    this.processErrors(errors)
  },

  onValidSubmit() {
    if (this.props.onValidSubmit) {
      this.props.onValidSubmit()
    }
  },

  render() {
    const { gettext } = this.props
    const formCursor = this.cursors.form
    const rootEntryTagsCursor = this.cursors.rootEntryTags.select('data')
    const entryTagGroupsCursor = this.cursors.entryTagGroups.select('data')

    return (
      <div style={{ flex: this.state.stepState.collapsed ? 0 : 1 }}>
        <Form
          cursor={formCursor}
          validationSchema={this.createValidationSchema(gettext)}
          onInvalidSubmit={this.onInvalidSubmit}
          onSubmit={this.onValidSubmit}
          formStateCursor={this.cursors.stepState.select('formState')}
          ref={(ref) => (this.form = ref)}
        >
          <CollapsibleStepContainer
            disabled={this.props.disableCollapsible}
            cursor={this.cursors.stepState.select('collapsed')}
            ref="container"
            title={gettext('Step 2. Add organizational tags to your group')}
            onCollapsedClick={() => this.state.stepState.collapsed}
            onCollapsedChange={this.props.onCollapsedChange}
          >
            <div className="mx-auto w-[980px] pb-2">
              <EntryTags
                tree={formCursor}
                rootEntryTagsCursor={rootEntryTagsCursor}
                entryTagGroupsCursor={entryTagGroupsCursor}
                poll={this.props.poll}
                stepCollapsed={this.state.stepState.collapsed}
              />
              <div className="mt-8 mb-16">
                <Submit className="btn-submit">
                  {this.props.submitText || gettext('Save & Continue')}
                </Submit>
              </div>
            </div>
          </CollapsibleStepContainer>
        </Form>
      </div>
    )
  },
})

export default withGettext(SecondStep)
